const ONBOARDING_KEY = 'telegram_miniapp_onboarding_completed'
const PIN_KEY = 'telegram_miniapp_pin'

export const onboardingUtils = {
  // Проверка, прошел ли пользователь онбординг
  isOnboardingCompleted() {
    return localStorage.getItem(ONBOARDING_KEY) === 'true'
  },

  // Отметить онбординг как завершенный
  completeOnboarding() {
    localStorage.setItem(ONBOARDING_KEY, 'true')
  },

  // Сохранить PIN-код
  savePin(pin) {
    localStorage.setItem(PIN_KEY, pin)
  },

  // Получить PIN-код
  getPin() {
    return localStorage.getItem(PIN_KEY)
  },

  // Проверить PIN-код
  verifyPin(pin) {
    return localStorage.getItem(PIN_KEY) === pin
  },

  // Сбросить данные (для тестирования)
  reset() {
    localStorage.removeItem(ONBOARDING_KEY)
    localStorage.removeItem(PIN_KEY)
  }
}
